import { axiosPrivate } from 'app/utils';
import helpers from './helpers';

export default {
  async getBroadcasts(pharmacyId) {
    const response = await axiosPrivate.get(`/pharmacies/${pharmacyId}/broadcasts`);

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  async getBroadcastSegmentationOptions(pharmacyId) {
    const response = await axiosPrivate.get(
      `/pharmacies/${pharmacyId}/broadcasts/segmentation-options`
    );

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  async getSegmentationReach(pharmacyId, filters) {
    const response = await axiosPrivate.post(`/pharmacies/${pharmacyId}/broadcasts/reach`, filters);

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  async createBroadcast(pharmacyId, message, filters) {
    const response = await axiosPrivate.post(`/pharmacies/${pharmacyId}/broadcast`, {
      message,
      filters,
    });

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },
};
